import { fetchJSON } from "lib/fetch";
import { getStore } from "store";
import config from "site-config";
import { updateLsidUserInfo } from "../actions/lsid-actions";

export interface LSIDUserInfo {
    sub?: string;
    given_name?: string;
    family_name?: string;
    email?: string;
    email_verified?: boolean;
    preferred_username?: string;
    mfa_challenge_types?: Array<"email" | "totp" | "recovery_code" | "remember_me_cookie" | "support_generated_otp">;
}

export interface IState {
    params: any;
    [prop: string]: any;
}
type TReplace = (params: any) => void;
type ICallback = () => void;

/**
 *  request against the LS identity-service to get userinfo for user
 *
 */
export default function (nextState: IState, replace: TReplace, callback: ICallback) {
    const store = getStore();
    const url = `${config.LSID_IDENTITY_ROOT}/oidc/userinfo`;
    fetchJSON<LSIDUserInfo>(url, { method: "GET" })
        .then((response) => {
            store.dispatch(updateLsidUserInfo(formatPayload(response)));
        })
        .catch((_error) => {
            // eslint-disable-next-line no-console
            console.error(_error);
        })
        .finally(() => {
            callback();
        });
}

const formatPayload = function (userinfo: LSIDUserInfo): {
    mfaChallengeTypes: NonNullable<LSIDUserInfo["mfa_challenge_types"]>;
} {
    return {
        mfaChallengeTypes: userinfo?.mfa_challenge_types || [],
    };
};
